import { define, EVENTS } from './theme.js';
class ProductGallery extends HTMLElement {
  connectedCallback() {
    this.life = new AbortController();
    const signal = this.life.signal;
    this.list = this.querySelector('[data-gallery-list]');
    this.items = [...this.list.children];
    this.dialog = this.querySelector('dialog');
    this.querySelectorAll('[data-deferred-play], [data-lightbox-open], [data-gallery-thumbs], [data-gallery-counter]').forEach(el => { el.hidden = false; });
    this.mediaQuery = matchMedia('(max-width: 749px)');
    this.layout = () => this.querySelectorAll('[data-gallery-prev], [data-gallery-next]').forEach(el => { el.hidden = !(this.mediaQuery.matches || this.getAttribute('layout') === 'carousel'); });
    this.mediaQuery.addEventListener('change', this.layout, { signal });
    this.layout();
    this.addEventListener('click', event => this.click(event), { signal });
    this.list.addEventListener('scroll', () => this.sync(), { signal, passive: true });
    document.addEventListener(EVENTS.variantChange, event => {
      if (event.detail.section === this.getAttribute('section') && event.detail.variant?.featured_media) this.select(String(event.detail.variant.featured_media.id));
    }, { signal });
    this.select(this.dataset.selectedMedia, false);
    const models = this.querySelector('[data-product-models]');
    if (models && window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{ name: 'shopify-xr', version: '1.0', onLoad: error => {
      if (error || !this.isConnected || !window.ShopifyXR) return;
      window.ShopifyXR.addModels(JSON.parse(models.textContent));
      window.ShopifyXR.setupXRElements();
    } }]);
  }
  disconnectedCallback() { this.life.abort(); this.dialog?.close(); this.pause(); }
  pause() {
    this.querySelectorAll('video').forEach(video => video.pause());
    this.querySelectorAll('.is-loaded').forEach(media => {
      if (media.querySelector('iframe')) { media.querySelector('iframe').remove(); media.classList.remove('is-loaded'); }
      media.querySelector('model-viewer')?.pause?.();
    });
  }
  select(id, smooth = true) {
    const item = this.items.find(el => el.dataset.mediaId === id);
    if (!item) return;
    this.pause();
    if (this.mediaQuery.matches || this.getAttribute('layout') === 'carousel') {
      const offset = item.getBoundingClientRect().left - this.list.getBoundingClientRect().left + this.list.scrollLeft;
      this.list.scrollTo({ left: offset, behavior: smooth && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant' });
    } else if (smooth) { this.list.prepend(item); this.items = [...this.list.children]; }
    this.index = this.items.indexOf(item);
    this.syncButtons();
  }
  sync() {
    const left = this.list.getBoundingClientRect().left;
    this.index = this.items.reduce((best, item, i) => Math.abs(item.getBoundingClientRect().left - left) < Math.abs(this.items[best].getBoundingClientRect().left - left) ? i : best, 0);
    this.syncButtons();
  }
  syncButtons() {
    const index = this.index || 0;
    this.querySelectorAll('[data-thumb]').forEach(el => el.setAttribute('aria-current', String(el.dataset.thumb === this.items[index]?.dataset.mediaId)));
    const current = this.querySelector('[data-gallery-current]'); if (current) current.textContent = index + 1;
    const prev = this.querySelector('[data-gallery-prev]'); if (prev) prev.disabled = index === 0;
    const next = this.querySelector('[data-gallery-next]'); if (next) next.disabled = index === this.items.length - 1;
  }
  click(event) {
    const button = event.target.closest('button'); if (!button) return;
    if (button.hasAttribute('data-thumb')) this.select(button.dataset.thumb);
    if (button.hasAttribute('data-gallery-prev')) this.select(this.items[(this.index || 0) - 1]?.dataset.mediaId);
    if (button.hasAttribute('data-gallery-next')) this.select(this.items[(this.index || 0) + 1]?.dataset.mediaId);
    if (button.hasAttribute('data-deferred-play')) {
      const media = button.closest('[data-media-type]');
      if (media.classList.contains('is-loaded')) return;
      this.pause();
      media.append(media.querySelector('template').content.cloneNode(true));
      media.classList.add('is-loaded');
      const playable = media.querySelector('video, iframe, model-viewer');
      playable?.focus();
      if (playable?.tagName === 'VIDEO') playable.play().catch(() => {});
      if (button.hasAttribute('data-model')) window.Shopify?.loadFeatures?.([{ name: 'model-viewer-ui', version: '1.0', onLoad: error => {
        if (!error && this.isConnected && window.Shopify.ModelViewerUI) new window.Shopify.ModelViewerUI(playable);
      } }]);
    }
    if (button.hasAttribute('data-lightbox-open') && this.dialog) {
      this.pause();
      this.dialog.showModal();
      const id = button.closest('[data-media-id]').dataset.mediaId;
      const list = this.dialog.querySelector('[data-lightbox-list]');
      const item = [...list.children].find(el => el.dataset.mediaId === id);
      list.scrollLeft = [...list.children].indexOf(item) * list.clientWidth;
    }
    if (button.hasAttribute('data-lightbox-close')) this.dialog.close();
    if (button.hasAttribute('data-lightbox-prev') || button.hasAttribute('data-lightbox-next')) {
      const list = this.dialog.querySelector('[data-lightbox-list]');
      list.scrollBy({ left: list.clientWidth * (button.hasAttribute('data-lightbox-next') ? 1 : -1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
  }
}
define('product-gallery', ProductGallery);
